import { render, staticRenderFns } from "./AddTheoryPracticeWorkshopLessonAttachmentModal.vue?vue&type=template&id=4818c288&scoped=true&"
import script from "./AddTheoryPracticeWorkshopLessonAttachmentModal.vue?vue&type=script&lang=js&"
export * from "./AddTheoryPracticeWorkshopLessonAttachmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTheoryPracticeWorkshopLessonAttachmentModal.vue?vue&type=style&index=0&id=4818c288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818c288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VContainer,VDialog,VFileInput,VRow,VSelect,VSpacer})
